/**
 *
 * @module PlayerType enum
 * @desc Player type enumeration
 *
 */
export default {
    HTML5: 'HTML5',
    HLSJS: 'HLSJS',
};
